import { render } from "./ProductCarousel.vue?vue&type=template&id=05b3c364&scoped=true"
import script from "./ProductCarousel.vue?vue&type=script&lang=js"
export * from "./ProductCarousel.vue?vue&type=script&lang=js"

import "./ProductCarousel.vue?vue&type=style&index=0&id=05b3c364&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b3c364"]])

export default __exports__